import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { getCodeColor } from "../components";



export const GeneratePdfReporteCompras = ({ pdfData, fechaIni, fechaFin, themeColor, convertPrice = (() => { }) }) => {
	const themeConverted = getCodeColor(themeColor);

	const styles = StyleSheet.create({
		page: {
			flexDirection: "column",
			padding: 10,
			fontSize: 10,
			fontFamily: "Helvetica",
		},
		headerContainer: {
			flexDirection: "row",
			alignContent: "center",
			paddingBottom: 10,
		},
		headerLeft: {
			flexDirection: "column",
			width: "40%",
			lineHeight: 1.2,
			fontSize: 7,
		},
		logo: {
			width: 150,
			height: 100,
		},
		titleBig: {
			fontFamily: "Helvetica-Bold",
			fontSize: 19,
			letterSpacing: 1,
			margin: 0,
			paddingLeft: 35,
			position: "relative",
			top: "15",
			right: "40",
		},
		subHeaderContainer: {
			flexDirection: "row",
			justifyContent: "space-between",
			paddingRight: "10",
			alignItems: "center",
			marginTop: 5,
			fontSize: 9,
		},
		tableContainer: {
			width: "100%",
			marginVertical: 10,
		},
		tableHeader: {
			flexDirection: "row",
			backgroundColor: themeConverted,
		},
		tableHeaderCell: {
			padding: 5,
			fontWeight: "bold",
			textAlign: "center",
			fontSize: 8,
			color: "white",
		},
		tableRow: {
			flexDirection: "row",
			borderBottomWidth: 1,
			borderBottomColor: "#dddddd",
		},
		tableCell: {
			padding: 5,
			textAlign: "center",
			fontSize: 8,
		},
		tableCellLeft: {
			padding: 5,
			textAlign: "left",
			fontSize: 8,
		},
		// Column widths
		tableCellNo: { flex: 0.5 },
		tableCellDate: { flex: 0.8 },
		tableCellCode: { flex: 1 },
		tableCellProduct: { flex: 2 },
		tableCellQuantity: { flex: 0.6 },
		tableCellCost: { flex: 0.8 },
		tableCellDiscount: { flex: 0.8 },
		tableCellPrice: { flex: 0.8 },

		tableRowTotal: {
			flexDirection: "row",
			backgroundColor: themeConverted,
		},
		totalCell: {
			padding: 5,
			textAlign: "center",
			fontSize: 8,
			color: "white",
			fontWeight: "bold",
		},

		signatureContainer: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-around",
			marginTop: 30,
		},
		signatureLine: {
			marginBottom: 5,
		},
		signatureBox: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		pageNumbers: {
			position: "absolute",
			bottom: 20,
			right: 20,
			textAlign: "right",
		},
	});

	if (!pdfData?.details) {
		return (
			<Document>
				<Page size="A4" style={styles.page}>
					<Text>No hay datos disponibles para el reporte...</Text>
				</Page>
			</Document>
		);
	}
	const apiUrl = process.env.REACT_APP_API_URL;
	// Calculate totals
	const totalQuantity = pdfData.details.reduce((acc, item) => acc + item.qp, 0);
	const totalCost = pdfData.details.reduce((acc, item) => acc + parseFloat(item.pPurchase || 0) * item.qp, 0);
	const totalDiscount = pdfData.details.reduce((acc, item) => acc + parseFloat(item.pDiscount || 0) * item.qp, 0);
	const totalSubtotal = pdfData.details.reduce((acc, item) => acc + parseFloat(parseFloat(item.pPurchase) - parseFloat(item.pDiscount)) * parseInt(item.qp), 0);

	return (
		<Document>
			<Page size="A4" style={styles.page}>
				{/* Header */}
				<View style={styles.headerContainer}>
					<View style={styles.headerLeft}>
						<View style={{ position: "relative", top: 7 }}>
							<Image
								source={`${apiUrl}${pdfData.logo}`}
								src={`${apiUrl}${pdfData.logo}`}
								style={styles.logo}
							/>
						</View>
						<View>
							<Text>Empresa: {pdfData.cName}</Text>
							<Text>Dirección: {pdfData.address}</Text>
							<View style={{ flexDirection: "row", marginTop: "2px" }}>
								<Text>NIT: {pdfData.cNit}</Text>
								<Text style={{ paddingLeft: 15 }}>Tel: {pdfData.phone}</Text>
							</View>
						</View>
					</View>
					<View style={{ justifyContent: "center", alignItems: "center" }}>
						<Text style={styles.titleBig}>Reporte de Compras</Text>
					</View>
				</View>
				{/*Sub-header */}
				<View style={styles.subHeaderContainer}>
					<View>
						<Text>
							Responsable: {pdfData.cashier_name} {/* Tel: {pdfData.cashier_phone} */}
						</Text>
					</View>
					<View style={{ display: "flex", flexDirection: "row", gap: "5" }}>
						<Text>{`${fechaIni} a ${fechaFin}`}</Text>
						<Text style={{ fontSize: 7, position: "relative", top: "1.5" }}>{pdfData.oTime}</Text>
					</View>
				</View>
				Table
				<View style={styles.tableContainer}>
					Table Header
					<View style={styles.tableHeader}>
						<Text style={[styles.tableHeaderCell, styles.tableCellNo]}>No</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellDate]}>Fecha</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellCode]}>Código</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellProduct]}>Producto</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellQuantity]}>Cantidad</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellCost]}>Precio C.</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellCost]}>Descuento</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellCost]}>Sub total</Text>
					</View>
					Table Rows
					{pdfData.details.map((item, index) => (
						<View style={styles.tableRow} key={item.code}>
							<Text style={[styles.tableCell, styles.tableCellNo]}>{index + 1}</Text>
							<Text style={[styles.tableCell, styles.tableCellDate]}>{item.dDate || pdfData.oDate}</Text>
							<Text style={[styles.tableCell, styles.tableCellCode]}>{item.code}</Text>
							<Text style={[styles.tableCellLeft, styles.tableCellProduct]}>{item.description}</Text>
							<Text style={[styles.tableCell, styles.tableCellQuantity]}>{item.qp}</Text>
							<Text style={[styles.tableCell, styles.tableCellCost]}>
								{convertPrice(item.pPurchase || 0, null, true)}
							</Text>
							<Text style={[styles.tableCell, styles.tableCellDiscount]}>{convertPrice(item.pDiscount, null, true)}</Text>
							<Text style={[styles.tableCell, styles.tableCellDiscount]}>
								{convertPrice((item.pPurchase - item.pDiscount) * item.qp, null, true)}
							</Text>
						</View>
					))}
					Totals Row
					<View style={styles.tableRowTotal}>
						<Text style={[styles.totalCell, { flex: 4.3, textAlign: "right" }]}>TOTAL</Text>
						<Text style={[styles.totalCell, styles.tableCellQuantity]}>{totalQuantity}</Text>
						<Text style={[styles.totalCell, styles.tableCellCost]}>{convertPrice(totalCost)}</Text>
						<Text style={[styles.totalCell, styles.tableCellQuantity]}>{convertPrice(totalDiscount)}</Text>
						<Text style={styles.totalCell}>
							{totalSubtotal < 0 && "-"}
							{convertPrice(Math.abs(totalSubtotal))}
						</Text>
					</View>
				</View>
				Signatures
				<View style={styles.signatureContainer}>
					<View style={styles.signatureBox}>
						<Text style={styles.signatureLine}>___________________________</Text>
						<Text>{pdfData.cashier_name}</Text>
						<Text>Responsable</Text>
					</View>
					<View style={styles.signatureBox}>
						<Text style={styles.signatureLine}>___________________________</Text>
						<Text>{pdfData.manager_name}</Text>
						<Text>Gerente General</Text>
					</View>
				</View>
				<Text
					style={styles.pageNumbers}
					render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
					fixed
				/>
			</Page>
		</Document>
	);
};
